import { Button, DatePicker, Form, Input, Space, Upload } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';

import { handleSubmit } from './helpers';
import type { EditFixRecordProps, FixRecordFormValues } from './types';

const EditFixRecord: React.FC<EditFixRecordProps> = ({
  fixId,
  editFixRecord,
  afterEdit,
  cancelEdit,
}) => {
  const [form] = Form.useForm<FixRecordFormValues>();

  useEffect(() => {
    const initialValues: Partial<FixRecordFormValues> = {
      status: editFixRecord.status,
    };
    if (editFixRecord.fixRecord) {
      initialValues.repairerName = editFixRecord.fixRecord.repairerName;
      initialValues.content = editFixRecord.fixRecord.content;
      initialValues.repairedTime = moment(editFixRecord.fixRecord.repairedTime);
      const initialImage = editFixRecord.fixRecord.image;
      if (initialImage) {
        initialValues.image = [
          {
            uid: '-1',
            name: initialImage.name,
            status: 'done',
            url: initialImage.path,
          },
        ];
      }
    }
    form.setFieldsValue(initialValues);
    return () => {
      form.resetFields();
    };
  }, [editFixRecord.fixRecord, editFixRecord.status, form]);

  return (
    <Form
      form={form}
      onFinish={(values) =>
        handleSubmit({
          values,
          fixId,
          editFixRecord,
          afterEdit,
        })
      }
      labelCol={{ span: 24 }}
    >
      <Form.Item
        name="status"
        label="狀態"
        required
        rules={[{ required: true, message: '請輸入狀態' }]}
      >
        <Input disabled />
      </Form.Item>
      <Form.Item
        name="repairerName"
        label="維修人員姓名"
        required
        rules={[{ required: true, message: '請輸入維修人員姓名' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="repairedTime"
        label="維修時間"
        required
        rules={[{ required: true, message: '請輸入維修時間' }]}
      >
        <DatePicker showTime={{ format: 'HH:mm' }} />
      </Form.Item>
      <Form.Item
        name="content"
        label="維修內容"
        required
        rules={[{ required: true, message: '請輸入維修內容' }]}
      >
        <Input.TextArea />
      </Form.Item>
      <Form.Item
        name="image"
        label="維修圖片"
        valuePropName="fileList"
        getValueFromEvent={(e) => {
          if (Array.isArray(e)) {
            return e;
          }
          return e && e.fileList;
        }}
      >
        <Upload
          name="image"
          beforeUpload={() => false}
          listType="picture"
          multiple={false}
          maxCount={1}
        >
          <Button>上傳圖片</Button>
        </Upload>
      </Form.Item>
      <Form.Item>
        <Space>
          <Button type="primary" htmlType="submit">
            確認
          </Button>
          <Button onClick={cancelEdit}>取消</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default EditFixRecord;
